import React from "react";
import Select from "../../components/select/Select";
import "./QuestionBuilder.css";

const QuestionBuilder = ({
  questionnaireState,
  handleQuestionDetails,
  addQuestion,
  sectionModified,
  addAnswer,
  handleAnswerDetails,
  errorInputs,
  setUpDeletion,
}) => {
  return (
    <div>
      <div
        className={
          "virtual_hold" +
          (questionnaireState.sections[sectionModified].questions &&
          questionnaireState.sections[sectionModified].questions.length === 0 &&
          errorInputs
            ? " sb_sec_err"
            : "")
        }
      >
        <div className="vth_title">Questions</div>
        {questionnaireState.sections[sectionModified].questions &&
          questionnaireState.sections[sectionModified].questions.map((question, q) => (
            <div key={q} className="vt_step_hold">
              <div
                className={"sb_inp_hold" + (question.question_number === "" && errorInputs ? " prog_err_input" : "")}
              >
                <div className="vt_inp_included select_main smnumber">
                  <div className="select_placeholder sp_act">Question Number</div>
                  <input
                    type="text"
                    value={question ? question.question_number : ""}
                    onChange={(e) =>
                      handleQuestionDetails([sectionModified, q, "question_number"], e.currentTarget.value)
                    }
                  />
                </div>
              </div>
              <div className={"sb_inp_hold" + (!question.question_title && errorInputs ? " prog_err_input" : "")}>
                <div className="vt_inp_included select_main qstlongtitle">
                  <div className="select_placeholder sp_act">Question Title</div>
                  <input
                    type="text"
                    value={question ? question.question_title : ""}
                    onChange={(e) =>
                      handleQuestionDetails([sectionModified, q, "question_title"], e.currentTarget.value)
                    }
                  />
                </div>
              </div>
              <div className={"sb_inp_hold" + (!question.question_subtitle && errorInputs ? " prog_err_input" : "")}>
                <div className="vt_inp_included select_main qstlongtitle"> 
                  <div className="select_placeholder sp_act">Question Subtitle</div>
                  <input
                    type="text"
                    value={question ? question.question_subtitle : ""}
                    onChange={(e) =>
                      handleQuestionDetails([sectionModified, q, "question_subtitle"], e.currentTarget.value)
                    }
                  />
                </div>
              </div>
              <div className="vt_select_hold">
                <Select
                  initVal={
                    question && question.question_type === "radio"
                      ? "Radio"
                      : question.question_type === "checkbox"
                      ? "Checkbox"
                      : question.question_type === "inputWithCheckbox"
                      ? "Input With Checkbox"
                      : question.question_type === "radioWithCheckbox"
                      ? "Radio With Checkbox"
                      : question.question_type === "slider"
                      ? "Slider"
                      : question.question_type === "subtitle"
                      ? "Subtitle"
                      : question.question_type === "numberInput"
                      ? "Number Input"
                      : question.question_type
                  }
                  placeholder="Question Type"
                  selectOptions={[
                    { value: "Radio" },
                    { value: "Checkbox" },
                    { value: "Input" },
                    { value: "Input With Checkbox" },
                    { value: "Radio With Input" },
                    { value: "Radio With Checkbox" },
                    { value: "Slider" },
                    { value: "Subtitle" },
                    { value: "Number Input" },
                  ]}
                  selectCallback={handleQuestionDetails}
                  callBackValue={[sectionModified, q, "question_type"]}
                  selectError={!question.question_type && errorInputs}
                />
              </div>
              <div className="vt_select_hold">
                <Select
                  initVal={question && question.fill_user_type ? question.fill_user_type : ""}
                  placeholder="Fill User Type"
                  selectOptions={[{ value: "Patient" }, { value: "Therapist" }]}
                  selectCallback={handleQuestionDetails}
                  callBackValue={[sectionModified, q, "fill_user_type"]}
                  selectError={!question.fill_user_type && errorInputs}
                />
              </div>
              <div className="vt_select_hold">
                <Select
                  initVal={question && question.show_condition_question ? question.show_condition_question : ""}
                  placeholder="Show condition question"
                  selectOptions={[{ value: "Yes" }, { value: "No" }]}
                  selectCallback={handleQuestionDetails}
                  callBackValue={[sectionModified, q, "show_condition_question"]}
                  selectError={!question.show_condition_question && errorInputs}
                />
              </div>
              {question && question.show_condition_question === "Yes" && (
                <div className="vt_inp_included select_main">
                  <div className="select_placeholder sp_act">Show condition value</div>
                  <input
                    type="text"
                    value={question ? question.show_condition_value : ""}
                    onChange={(e) =>
                      handleQuestionDetails([sectionModified, q, "show_condition_value"], e.currentTarget.value)
                    }
                  />
                </div>
              )}
              <div className="vt_select_hold">
                <Select
                  initVal={question && question.db_write ? question.db_write : ""}
                  placeholder="Database Write"
                  selectOptions={[{ value: "Yes" }, { value: "No" }]}
                  selectCallback={handleQuestionDetails}
                  callBackValue={[sectionModified, q, "db_write"]}
                  selectError={!question.db_write && errorInputs}
                />
              </div>
              {question && question.db_write === "Yes" && (
                <>
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Database Write Table</div>
                    <input
                      type="text"
                      value={question ? question.db_write_table : ""}
                      onChange={(e) =>
                        handleQuestionDetails([sectionModified, q, "db_write_table"], e.currentTarget.value)
                      }
                    />
                  </div>
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Database Write Field</div>
                    <input
                      type="text"
                      value={question ? question.db_write_field : ""}
                      onChange={(e) =>
                        handleQuestionDetails([sectionModified, q, "db_write_field"], e.currentTarget.value)
                      }
                    />
                  </div>
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Database Write Condition</div>
                    <input
                      type="text"
                      value={question ? question.db_write_condition : ""}
                      onChange={(e) =>
                        handleQuestionDetails([sectionModified, q, "db_write_condition"], e.currentTarget.value)
                      }
                    />
                  </div>
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Database Write Add Update</div>
                    <input
                      type="text"
                      value={question ? question.db_write_add_update : ""}
                      onChange={(e) =>
                        handleQuestionDetails([sectionModified, q, "db_write_add_update"], e.currentTarget.value)
                      }
                    />
                  </div>
                </>
              )}
              {questionnaireState.sections[sectionModified].questions[q].answers &&
                questionnaireState.sections[sectionModified].questions[q].answers.map((answer, a) => (
                  <div key={a} className="vt_step_hold">
                    <div className={"sb_inp_hold" + (!answer.answer && errorInputs ? " prog_err_input" : "")}>
                      <div className="vt_inp_included select_main">
                        <div className="select_placeholder sp_act">Answer Name</div>
                        <input
                          type="text"
                          value={answer ? answer.answer : ""}
                          onChange={(e) =>
                            handleAnswerDetails([sectionModified, q, a, "answer"], e.currentTarget.value)
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={"sb_inp_hold" + (answer.answer_weight === "" && errorInputs ? " prog_err_input" : "")}
                    >
                      <div className="vt_inp_included select_main">
                        <div className="select_placeholder sp_act">Answer Weight</div>
                        <input
                          type="text"
                          value={answer ? answer.answer_weight : ""}
                          onChange={(e) =>
                            handleAnswerDetails([sectionModified, q, a, "answer_weight"], e.currentTarget.value, true)
                          }
                        />
                      </div>
                    </div>
                    <div
                      className="vt_add item_dlt_color"
                      onClick={() => setUpDeletion([sectionModified, q, a], "Answer", answer.answer_id)}
                    >
                      Delete Answer
                    </div>
                  </div>
                ))}

              <div className="vt_add vt_add_left" onClick={() => addAnswer([sectionModified, q, question.question_id])}>
                Add Answer
              </div>
              <div
                className="vt_add item_dlt_color"
                onClick={() => setUpDeletion([sectionModified, q], "Question", question.question_id)}
              >
                Delete Question
              </div>
            </div>
          ))}
        <div className="vt_add" onClick={() => addQuestion(sectionModified)}>
          Add Question
        </div>
      </div>
    </div>
  );
};

export default QuestionBuilder;
